module.exports = __webpack_public_path__ + "img/pulled_pork_fridge.6b0a6dba.jpg";